import React from 'react';
import { Route, Routes } from 'react-router-dom';

import loadable from '@loadable/component';

import {
	BOOKING_APPOINTMENT,
	BOOKING_ARRANGEMENTS,
	BOOKING_CONFIRMATION,
	BOOKING_FAMILY,
	BOOKING_PAYMENT,
	BOOKING_PET,
	BOOKING_PHONE_VERIFICATION,
	BOOKING_SCHEDULE,
} from '@app/components/LocalCommon/Utils/booking';
import HeartLoader from '@app/components/UI/HeartLoader/HeartLoader';
import useOnlineBookingTracking from '@app/hooks/useOnlineBookingTracking';
import { OnlineBookingEntry } from '@app/objects/OnlineBooking';

interface InformationProps {
	setResult?: (val: OnlineBookingEntry | undefined) => void;
}

const fallback = {
	fallback: (
		<div className="bg-white online-booking-information-content">
			<div className="center-center-content">
				<div className="online-booking-information-content__content">
					<HeartLoader />
				</div>
			</div>
		</div>
	),
};

const FamilyInformation = loadable(() => import('@app/components/Pages/Booking/FamilyInformation/FamilyInformation'), fallback);
const Pet = loadable(() => import('@app/components/Pages/Booking/Pet/Pet'), fallback);
const Appointment = loadable(() => import('@app/components/Pages/Booking/Appointment/Appointment'), fallback);
const Arrangements = loadable(() => import('@app/components/Pages/Booking/Arrangements/Arrangements'), fallback);
const Confirmation = loadable(() => import('@app/components/Pages/Booking/Confirmation/Confirmation'), fallback);
const Schedule = loadable(() => import('@app/components/Pages/Booking/Schedule/Schedule'), fallback);
const Payment = loadable(() => import('@app/components/Pages/Booking/Payment/Payment'), fallback);

const BookingStep: React.FC<InformationProps> = () => {
	useOnlineBookingTracking();

	return (
		<Routes>
			<Route path={BOOKING_PHONE_VERIFICATION} element={<FamilyInformation />} />
			<Route path={BOOKING_FAMILY} element={<FamilyInformation />} />
			<Route path={BOOKING_PET} element={<Pet />} />
			<Route path={BOOKING_APPOINTMENT} element={<Appointment />} />
			<Route path={BOOKING_ARRANGEMENTS} element={<Arrangements />} />
			<Route path={BOOKING_CONFIRMATION} element={<Confirmation />} />
			<Route path={BOOKING_SCHEDULE} element={<Schedule />} />
			<Route path={BOOKING_PAYMENT} element={<Payment />} />
		</Routes>
	);
};

export default BookingStep;
